import React from "react";
import {
  Box,
  Center,
  Divider,
  Flex,
  Heading,
  Link,
  ListItem,
  Stack,
  Text,
  Icon,
  UnorderedList,
  Image,
  Tag,
  Button,
  HStack,
} from "@chakra-ui/react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component/dist-modules";
import "react-vertical-timeline-component/style.min.css";
import { wrap } from "framer-motion";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faSchool,
  faStar,
  fafaceboo,
} from "@fortawesome/free-solid-svg-icons";
import { FaGithub } from "react-icons/fa";
import { GrDeploy } from "react-icons/gr";
function Projects(props) {
  const projectList = [
    {
      project: "Royal Brothers - Clone",
      date: "images/royal.svg",
      site: "https://symphonious-cupcake-6a58b9.netlify.app/",
      github: "https://github.com/saintlypioneer/RoyalBrothersReact",
      about: [
        `Royal Brothers is India’s largest mobility
            solutions provider, providing rentals spanning 14
            states, 43 cities, and 3 international cities.
            `,
        `Group Project: 4 Collaborators | Duration 5 Days`,
      ],
      features: `A user can search for bikes based on his
            required location and filter available bikes based
            on his timeline. Users can select any model from a
            wide range of models listed. Fully responsive
            website.
            `,
      tech: [
        "React",
        "Redux",
        "Javascript",
        "Chakra UI",
        "HTML",
        "CSS",
        "REST API",
      ],
      anim: "images/prroyal.gif",
    },
    {
      project: "MyFitnessPal - Clone",
      date: "images/fitnesspal.png",
      site: "https://cw-06-myfitnesspal.netlify.app/",
      github: "https://github.com/dilasathapa/myfitnesspal-clone",
      about: [
        `MyFitnessPal is a health and fitness tracker
            application.`,
        `Group Project: 4 Collaborators | Duration: 5 Days`,
      ],
      features: `Register on the website by specifying
            fitness goals, managing user profiles, food diaries,
            and exercise diaries, and generating printable
            diet and exercise reports`,
      tech: ["React", "Redux", "HTML", "CSS", "JavaScript"],
      anim: "images/prfitnesspal.gif",
    },
    {
      project: "PharmEasy - Clone",
      date: "https://assets.pharmeasy.in/apothecary/images/favicon.png",
      site: "https://pharmeasy-clone-707ee3.netlify.app/",
      github: "https://github.com/rachnarajaka040/PharmEasy_clone",
      about: [
        `PharmEasy is an Indian e-pharmacy company
            that sells medicines, diagnostics, and telehealth
            online`,
        `Group Project: 5 Collaborators | Duration 5 Days.`,
      ],
      features: ` Login, Signup, Filter, Add to Cart, Delete
            functionality, and custom REST API is developed.`,
      tech: ["HTML", "CSS", "Javascript", "Local Storage", "REST API"],
      anim: "images/prpharmeasy.gif",
    },
    {
      project: "Drivezy - Clone",
      date: "images/drivezy.png",
      site: "https://drivezy-clone.netlify.app/",
      github: "https://github.com/viz404/Vehicle-Rental-Application",
      about: [
        `Vehicle rental web application with the ability to perform search, select date and time to pick up the vehicle, switch between bike and car, search using city. Ability to filter using type of vehicle and apply sort.`,
      ],
      features: ` `,
      tech: ["HTML", "CSS", "Javascript", "Local Storage"],
      anim: "images/prdrivezy.gif",
    },
  ];
  let workIconStyles = { background: "#EDAC33" };
  return (
    <Box
      w={{ base: "95%", md: "80%" }}
      margin={"auto"}
      padding="5%"
      border={"solid #ffd3366b"}
      borderRadius="40px"
      id="projects"
    >
      <Box textAlign={"left"} w="100%" margin={"auto"}>
        <Heading textAlign={"center"} mb={10} fontSize={30} color={"cpdark"}>
          Some of My Projects
        </Heading>

        <VerticalTimeline>
          {projectList.map((ele, index) => {
            return (
              <VerticalTimelineElement
                contentStyle={{ background: "#14213f", color: "#ffffff" }}
                contentArrowStyle={{ borderRight: "7px solid #ffffff" }}
                className="vertical-timeline-element--work"
                key={index}
                date={
                  <Box
                    width={"100%"}
                    padding={2}
                    bg={"white"}
                    borderRadius={10}
                    textAlign={"center"}
                  >
                    <Image
                      border={"solid 2px #202E4E"}
                      borderRadius={10}
                      src={ele.anim}
                    ></Image>
                    <HStack justifyContent={"center"}>
                      <Link isExternal href={ele.github}>
                        <Button colorScheme={"blue"} mt={2}>
                          {<FaGithub />}
                        </Button>
                      </Link>
                       <Link isExternal href={ele.site}>
                        <Button color={"white"} colorScheme={"yellow"} mt={2}>
                          {<GrDeploy />}
                        </Button>
                      </Link>
                    </HStack>
                  </Box>
                }
                icon={
                  <Box
                    display="flex"
                    justifyContent={"center"}
                    alignItems="center"
                    padding={2}
                    transition={"all 0.3s ease-out"}
                  >
                    <Image
                      src={ele.date}
                      alt="SUHAIL K"
                      fallbackSrc="https://via.placeholder.com/150"
                      objectFit={"fill"}
                    ></Image>
                  </Box>
                }
                iconStyle={workIconStyles}
              >
                <Stack>
                  <Link
                    fontSize="20px"
                    color={"cplite"}
                    fontWeight={600}
                    href={ele.site}
                    isExternal
                  >
                    {ele.project} <ExternalLinkIcon mx="2px" />
                  </Link>

                  <Stack>
                    <h5>{ele.about[0]}</h5>
                    <h5>{ele.features}</h5>
                  </Stack>

                  <Flex gap={2} flexWrap={"wrap"}>
                    {ele.tech.map((elem, ind) => {
                      return (
                        <Tag key={ind} colorScheme={"yellow"}>
                          {elem}
                        </Tag>
                      );
                    })}
                  </Flex>
                </Stack>
              </VerticalTimelineElement>
            );
          })}
        </VerticalTimeline>
      </Box>
    </Box>
  );
}

export default Projects;
